import { useAuthQuery } from 'hooks';
import { DCFPlayer } from 'types';

export const useDCFStep = (stageId: number) => {
  return useAuthQuery<DCFPlayer[]>(['dcf', stageId, 'players']);
};
